import Vue from "vue";
import Vuex from "vuex";
import * as filters from "@/store/modules/filters.js";
import * as user from "@/store/modules/user.js";
import * as projects from "@/store/modules/projects.js";
import * as project from "@/store/modules/project.js";
import * as columnVisibility from "@/store/modules/columnVisibility.js";
import * as notification from "@/store/modules/notification.js";
import * as rules from "@/store/modules/rules.js";
import * as sessionHistory from "@/store/modules/sessionHistory.js";
import * as groupFilters from "@/store/modules/groupFilters.js";
import * as users from "@/store/modules/users.js";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    filters,
    groupFilters,
    user,
    users,
    projects,
    project,
    columnVisibility,
    notification,
    rules,
    sessionHistory,
  },
});
